import { AppState } from 'Store'

const getAll = (state: AppState) => state.logs.preRecord.data
const getRequestParams = (state: AppState) => state.logs.preRecord.requestParams

export const preRecordSelector = {
	getAll,
	getRequestParams,
}
